import {Options} from "@interstate/components/RadioButtonList";
import {labelForPrimaryAddress} from "./labelForPrimaryAddress";
import {PrimaryClientAddress} from "./PrimaryClientAddress";

/**
 * The {@link toRadioButtonOption} function converts a {@link PrimaryClientAddress}
 * into an {@link Options} object suitable for use in a {@link RadioButtonList}.
 *
 * @param primary
 *
 * @see {@link labelForPrimaryAddress}
 */
export const toRadioButtonOption = (
  primary: PrimaryClientAddress
): Options => ({
  value: primary.key,
  label: labelForPrimaryAddress(primary)
});
